import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { TPlan } from '@/config/types'
import { PageName } from '@/enums/pageName'
import { PaymentMethod, PaymentPlatform } from '@/enums/payments'
import { getPath } from '@/utils/urlUtils'

import { PrimaryButton } from '@/components/buttons/primaryButton'

import { useAuth } from '@/auth/useAuth'
import { useSession } from '@/core/session/useSession'
import { trackPageView } from '@/events/events'

import { TPaymentFailPageProps } from './types'

const pageName = PageName.paymentFailed

export const PaymentFailPage = ({
  pageConfig,
  pagesOrder,
  setItem,
  getItem,
  config,
}: TPaymentFailPageProps) => {
  const { user } = useAuth()
  const sessionContext = useSession()
  const navigate = useNavigate()
  const {
    paymentTitle,
    pageTitle,
    message,
    buttonName,
    iconNode,
    messageImgNode,
    footerImg,
    plansDetails,
  } = pageConfig

  const selectedPlanId = getItem(PageName.selectPlan)
  const planData = useMemo<TPlan | undefined>(
    () => plansDetails.find((plan) => plan.planId === selectedPlanId),
    [plansDetails, selectedPlanId]
  )
  const paymentMethod = (getItem('paymentMethod') as PaymentMethod) || undefined
  const paymentPlatform = (getItem('paymentPlatform') as PaymentPlatform) || undefined

  useEffect(
    () => {
      trackPageView(
        pageName,
        config.PARTNER_ID,
        config.APP_ID,
        config.PAGE_SET_ID,
        sessionContext,
        user,
        [],
        [],
        planData?.internalPlanId,
        paymentMethod,
        paymentPlatform
      )
      document.title = pageTitle
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const onClick = () => {
    setItem && setItem('openPaymentPopup', '1')
    const paymentPage: PageName | undefined = pagesOrder.find((el) => el === PageName.paymentScreen)
    navigate(getPath(paymentPage || PageName.selectPlan))
  }

  const className = `page page-${pageName}`

  return (
    <div className={className}>
      <div className="title">
        {iconNode && iconNode}
        <div className="text" dangerouslySetInnerHTML={{ __html: paymentTitle }} />
      </div>
      <div className="error-message" dangerouslySetInnerHTML={{ __html: message }} />
      {messageImgNode && <div className="image-container">{messageImgNode}</div>}
      <div className="button-container">
        <PrimaryButton onClick={onClick}>{buttonName}</PrimaryButton>
      </div>
      {footerImg && <div className={'footer-container'}>{footerImg}</div>}
    </div>
  )
}
